import React from 'react';

import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';

import { Drawer } from 'components/shared/index';

import { AccountForm } from './AccountForm';

interface Props {
  open: boolean;
  onClose: () => void;
}

export const AccountDetailsDrawer: React.FC<Props> = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Drawer open={open} onClose={onClose} title={t('accountDetails')}>
      <Box sx={{ minWidth: 400 }}>
        <AccountForm onClose={onClose} />
      </Box>
    </Drawer>
  );
};
